import { useCallback } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next/useAnalyticsEvents';

import {
	fireLoomCjnEligibilityChecked,
	getCustomExperimentAnalytics,
} from '../../services/analytics.ts';
import type { LoomEventCacheKey, LoomEventCacheValue } from '../../services/caching.ts';
import { cjnLoomEventCacheController } from '../../services/caching.ts';

export const useFireOnlyNewLoomEvent = (): (({
	value,
	key,
}: {
	value: LoomEventCacheValue;
	key: LoomEventCacheKey | string;
}) => void) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const customAnalytics = getCustomExperimentAnalytics('crossJoinNudges', createAnalyticsEvent);

	/**
	 * Fire event only in case the event value has not been cached or cached value is different
	 * to prevent excessive number of analytics calls.
	 */
	return useCallback(
		({ value, key }: { value: LoomEventCacheValue; key: LoomEventCacheKey | string }) => {
			try {
				const cachedValue = cjnLoomEventCacheController.get(key);
				if (
					!cachedValue ||
					cachedValue.eligible !== value.eligible ||
					cachedValue.ineligibilityReason !== value.ineligibilityReason
				) {
					fireLoomCjnEligibilityChecked(customAnalytics, {
						...value,
						key,
					});
					cjnLoomEventCacheController.set(key, value);
				}
			} catch (e) {
				// cache get fail, do nothing
			}
		},
		[customAnalytics],
	);
};
